export default {
  API_ERROR: "Ne pare rău, ceva nu a funcționat. Vă rugăm să încercați din nou.",
  FORM_ERROR: "Ne pare rău, dar trebuie să scrieți ceva mai mult pentru a ne trimite feedback."
}